<script>
import Modal from '../../../components/Modal.vue'

export default {
    components: {
        Modal
    },
    
    props: {
        enableSendToSage: {
            type: Boolean,
            required: false
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
        passSendToSage() {
            this.$emit('passSendToSage')
        },
        passOnly() {
            this.$emit('passOnly')
        },
    }
}
</script>

<template>
    <modal ref="modal" heading="Pass Applicant">
        
        <div class="mb-4">
            <h5>You are moving this candidate to Loading Offer<span v-if="enableSendToSage">, would you like to Send this Candidate to Sage?</span><span v-else style="color:red"> but please note this candidate will not be sent to Sage. Please check that the correct External Req # and Sage Req ID are linked to this candidate application, and retry sending to Sage</span>
            </h5>
        </div>

        <div class="grid-x grid-padding-x align-right">
            <div class="cell shrink">
                <button v-if="enableSendToSage" class="button" type="button" @click="passSendToSage">Send to Sage</button>
                <button v-else disabled title="You can not Send to Sage, please check that the correct External Req # and Sage Req ID are linked to this candidate application before trying again" class="button disabled">Send to Sage</button>
            </div>

            <div class="cell shrink">
                <button v-if="enableSendToSage" class="button warning" type="button" @click="passOnly">
                    No do not send to Sage, just to Loading Offer
                </button>
                <button v-else class="button warning" type="button" @click="passOnly">
                    Move to Loading offer
                </button>
            </div>
        </div>
    </modal>
</template>